import { createContext, useContext } from 'react';
import type { ProcessingJob, SubmissionPayload } from '@/shared/types';

export type ProcessingContextValue = {
  jobs: ProcessingJob[];
  submitJob: (payload: SubmissionPayload) => Promise<string>;
  // Asks the backend to resume a failed/incomplete job, flips it back to a polled
  // state, and re-syncs the library so the poller picks it up again.
  resumeJob: (jobId: string) => Promise<void>;
  confirmJob: (jobId: string) => Promise<void>;
  cancelJob: (jobId: string) => Promise<void>;
  // Approves the exact character versions the user reviewed and moves the job on to
  // rendering. Rejects (409 references_changed, …) without changing the job.
  approveReferences: (jobId: string, reviewedVersions: Record<string, number>) => Promise<void>;
  deleteJob: (jobId: string) => Promise<void>;
  forgetJob: (jobId: string) => void;
};

export const ProcessingContext = createContext<ProcessingContextValue | undefined>(undefined);

export function useProcessing() {
  const ctx = useContext(ProcessingContext);
  if (!ctx) {
    throw new Error('useProcessing must be used within a ProcessingProvider');
  }
  return ctx;
}
